import React from 'react';
import { Phone, Mail, MapPin, Clock, Building, Award, Users, Shield } from 'lucide-react';
const CompanyBranch = () => {
  return (
    <div className="bg-gray-50 min-h-screen py-12">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold text-green-700 mb-4">
            Company Branch
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Your trusted partner for financial growth. With our expertise and commitment, 
            we help you achieve your financial dreams.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          <div className="bg-white rounded-xl shadow-md p-6 text-center hover:shadow-lg transition-shadow">
            <Phone className="w-12 h-12 text-green-600 mx-auto mb-4" />
            <h3 className="text-lg font-semibold text-gray-800 mb-2">Call Anytime</h3>
            <a href="tel:+918887141052" className="text-green-600 hover:text-green-700 font-medium">
              +91 88871 41052
            </a>
            <p className="text-sm text-gray-500 mt-2">Mon - Sat: 10AM - 7PM</p>
          </div>

          <div className="bg-white rounded-xl shadow-md p-6 text-center hover:shadow-lg transition-shadow">
            <Mail className="w-12 h-12 text-green-600 mx-auto mb-4" />
            <h3 className="text-lg font-semibold text-gray-800 mb-2">Official Email</h3>
            <a href="mailto:info@cashpro.co.in" className="text-green-600 hover:text-green-700 font-medium">
              info@cashpro.co.in
            </a>
            <p className="text-sm text-gray-500 mt-2">We reply within 2 hours</p>
          </div>
          <div className="bg-white rounded-xl shadow-md p-6 text-center hover:shadow-lg transition-shadow">
            <MapPin className="w-12 h-12 text-green-600 mx-auto mb-4" />
            <h3 className="text-lg font-semibold text-gray-800 mb-2">Main Office</h3>
            <p className="text-gray-600">
              2nd Floor, Bhawani Complex,<br />
              Sigra Rathyatra Road,<br />
              Above SBI Bank, Varanasi - 221010
            </p>
          </div>
          <div className="bg-white rounded-xl shadow-md p-6 text-center hover:shadow-lg transition-shadow">
            <Clock className="w-12 h-12 text-green-600 mx-auto mb-4" />
            <h3 className="text-lg font-semibold text-gray-800 mb-2">Working Hours</h3>
            <p className="text-gray-600">Mon - Sat: 10:00 AM – 07:00 PM</p>
            <p className="text-gray-500 text-sm mt-1">Sunday Closed</p>
          </div>
        </div>
        <div className="bg-white rounded-xl shadow-md p-8 mb-16">
          <div className="flex items-center gap-3 mb-6">
            <Building className="w-8 h-8 text-green-600" />
            <h2 className="text-2xl font-bold text-gray-800">About  CashPro Financial Services</h2>
          </div>
          <p className="text-gray-700 mb-4 leading-relaxed">
             CashPro Financial Services is a leading financial consulting firm dedicated to providing 
            comprehensive loan solutions and financial advisory services across India. With our deep 
            industry expertise and strong network of partner banks & NBFCs, we help individuals and 
            businesses secure the best financial products tailored to their unique needs.
          </p>
          <p className="text-gray-700 mb-4 leading-relaxed">
            Our mission is to make finance simple, transparent, and accessible. We believe in building 
            lasting relationships with our clients by offering unbiased advice, zero fees, and a 
            hassle-free experience. Whether you need a personal loan, home loan, business loan, or 
            insurance, our dedicated team ensures you get the best deals with minimal documentation 
            and quick disbursal.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8">
            <div className="flex items-start gap-3">
              <Award className="w-6 h-6 text-green-600 flex-shrink-0 mt-1" />
              <div>
                <h4 className="font-semibold text-gray-800">Industry Expertise</h4>
                <p className="text-sm text-gray-600">10+ years of experience in financial services</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <Users className="w-6 h-6 text-green-600 flex-shrink-0 mt-1" />
              <div>
                <h4 className="font-semibold text-gray-800">Trusted by Thousands</h4>
                <p className="text-sm text-gray-600">10,000+ satisfied customers across India</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <Shield className="w-6 h-6 text-green-600 flex-shrink-0 mt-1" />
              <div>
                <h4 className="font-semibold text-gray-800">Unbiased Advisory</h4>
                <p className="text-sm text-gray-600">Free consultation, no hidden charges</p>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-gradient-to-r from-green-50 to-emerald-50 rounded-xl p-8 text-center">
          <h2 className="text-2xl font-bold text-gray-800 mb-3">
            Have questions about loans?
          </h2>
          <p className="text-gray-600 mb-6 max-w-2xl mx-auto">
            Our experts usually respond within 2 hours. Reach out to us anytime for personalized assistance.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <a
              href="tel:+918887141052"
              className="inline-flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white font-semibold px-6 py-3 rounded-lg transition-all duration-300 shadow-md hover:shadow-lg"
            >
              <Phone size={18} />
              Call Now
            </a>
            <a
              href="mailto:info@cashpro.co.in"
              className="inline-flex items-center gap-2 bg-white hover:bg-gray-50 text-green-600 border border-green-200 font-semibold px-6 py-3 rounded-lg transition-all duration-300 shadow-md hover:shadow-lg"
            >
              <Mail size={18} />
              Email Us
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanyBranch;